import React, { useState } from "react";
import {
  Typography,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import useDashboardStore from "@/state/dashboard";
import { shallow } from "zustand/shallow";
import "./WidgetContainer2.css";
import "../Widgets/Widgets.css";

const WidgetContainer2 = (props, ref) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    style,
    styleWidget,
    className,
    onMouseDown,
    onMouseUp,
    onTouchEnd,
    dashboardIndex,
    widgetIndex,
    childrenWidgets,
    controlButtons = [],
    headerRightItem = null,
  } = props;
  const { dashboardState, selectWidgetChild } = useDashboardStore(
    (state) => ({
      dashboardState: state.dashboardState,
      selectWidgetChild: state.selectWidgetChild,
    }),
    shallow
  );
  const selectedChildrenIndex =
    dashboardState[dashboardIndex].widgets[widgetIndex].selectedChildren;

  const currentTitle = childrenWidgets[selectedChildrenIndex]?.title;
  const brife = childrenWidgets[selectedChildrenIndex]?.brife;

  const handleClosePopover = () => {
    setAnchorEl(null);
  };
  return (
    <div
      className={`${className} widget-container-2`}
      style={{ ...style }}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      {currentTitle ? (
        <div
          className="widget-title-2"
          style={{ width: childrenWidgets.length === 1 ? "100%" : undefined }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 10,
            }}
          >
            <div
              style={{
                fontSize: "28px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {currentTitle}
            </div>
            {brife ? (
              <Typography variant="widgetTitle" style={{ fontStyle: "italic" }}>
                {brife}
              </Typography>
            ) : null}
          </div>

          {controlButtons.map((button) => (
            <div>{button}</div>
          ))}
          {childrenWidgets.length > 1 && (
            <div>
              <IconButton
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
              >
                <FontAwesomeIcon icon={faEllipsis} style={{ fontSize: 22 }} />
              </IconButton>
            </div>
          )}

          {headerRightItem ? headerRightItem : null}
        </div>
      ) : null}
      <div className="widget-content-2" style={{ ...styleWidget }}>
        {childrenWidgets[selectedChildrenIndex].widget}
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div className="widget-children-selector-container">
          <List>
            {childrenWidgets.map((child, index) => {
              return (
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      selectWidgetChild(dashboardIndex, widgetIndex, index);
                      setAnchorEl(null);
                    }}
                  >
                    <ListItemText primary={child.title} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default React.forwardRef(WidgetContainer2);
